import { buyActions } from '@modules/buy';
import { notificationsActions } from '@modules/notifications';
import { NotificationTypesEnum } from '@modules/notifications/types';
import { sellActions } from '@modules/sell';
import { TMiddleware } from '@modules/types';
import { withdrawActions } from '@modules/withdraw';

export const invalidCurrencyError: TMiddleware = store => next => action => {
  const isGetRateAction = [
    buyActions.getBuyRate.rejected.type,
    buyActions.getRapydBuyRate.rejected.type,
    sellActions.getSellRate.rejected.type,
    withdrawActions.getWithdrawRate.rejected.type,
  ].includes(action.type);

  if (isGetRateAction) {
    const { code, data, name, title } = action.payload;
    const message = data?.from?.[0] || data?.to?.[0];
    const type = NotificationTypesEnum.error;
    if (code === CONST.errorCodes.invalidCurrencyError && !!message) {
      store.dispatch(notificationsActions.add({ title: title || name, message, type }));
    }
  }
  return next(action);
};

export default invalidCurrencyError;
